<template>
  <div id="allJobs">
    <h1>Ofertas</h1>
    <input type="text" v-model="search" placeholder="Procurar Emprego" />
    <select class="form-select" v-model="state">
      <option value="all">Todos</option>
      <option value="0">Visível</option>
      <option value="1">Invisível</option>
    </select>
    <div class="row align-self-stretch">
      <div v-for="job in filter" :key="job.jobs_id">
        <span v-if="job.del == 0">
          <AllJobs
            :name="job.name"
            :code="job.code_job"
            :date="job.create_date"
            :total="job.total"
            :id="job.jobs_id"
            :state="job.state"
            :description="job.description"
            :profile="job.profile"
            :offer="job.offer"
          ></AllJobs>
        </span>
      </div>
    </div>
    <span v-if="this.total > 1">
      <span v-if="this.currentPage == 1">
        <button
          @click="prevPage()"
          type="button"
          class="btn btn-primary"
          disabled
        >
          Prev
        </button></span
      >
      <span v-else>
        <button @click="prevPage()" type="button" class="btn btn-primary">
          Prev
        </button>
      </span>
      {{ currentPage }}/{{ total }}
      <span v-if="this.currentPage == this.total"
        ><button
          @click="nextPage()"
          type="button"
          class="btn btn-primary"
          disabled
        >
          Next
        </button></span
      >
      <span v-else>
        <button @click="nextPage()" type="button" class="btn btn-primary">
          Next
        </button></span
      >
    </span>
  </div>
</template>

<script>
import AllJobs from "@/components/AllJobs.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    AllJobs,
  },
  data: function() {
    return {
      jobs: [],
      jobs1: [],
      search: "",
      length: "",
      totalPage: "",
      actualPage: [],
      pages: [],
      applications: [],
      currentPage: 1,
      pageSize: 12,
      total: "",
      state: "all",
    };
  },
  methods: {
    async getAllJobs() {
      try {
        await this.$store.dispatch("fetchJobs");
        this.jobs1 = this.getJobs.data;
      } catch (err) {
        this.$swal({
          title: err,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
      this.changeFormatDate();
      this.getAllApplicattions();
    },
    async changeFormatDate() {
      for (let i = 0; i < this.jobs1.length; i++) {
        this.jobs1[i].create_date = new Date(this.jobs1[i].create_date)
          .toISOString()
          .slice(0, 10);
      }
    },
    async getNumbers() {
      this.length = this.jobs.length;
      this.totalPage = Math.ceil(this.length / 3);
      for (let i = 1; i <= this.totalPage; i++) {
        this.pages.push({ n: i });
      }
    },
    async prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    async nextPage() {
      if (this.currentPage * this.pageSize < this.searchBar.length) {
        this.currentPage++;
      }
    },
    async getAllApplicattions() {
      try {
        await this.$store.dispatch("fetchApplications");
        this.applications = this.getApplications.data;
        this.jobs = this.jobs1;
        for (let i = 0; i < this.jobs.length; i++) {
          let count = 0;
          for (let j = 0; j < this.applications.length; j++) {
            if (this.jobs[i].jobs_id == this.applications[j].id_jobs) {
              count++;
            }
          }
          this.jobs[i].total = count;
        }
      } catch (err) {
        this.$swal({
          title: err,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
  },
  created() {
    this.getAllJobs();
    this.getNumbers();
    this.changePage(1);
  },
  computed: {
    ...mapGetters(["getJobs"]),
    ...mapGetters(["getApplications"]),
    searchBar() {
      return this.jobs.filter((job) => {
        let filterSearch = true;
        let filterState = true;
        if (this.search == "" && this.state == "all") {
          return filterSearch && filterState;
        }
        if (this.search !== "") {
          if (job.name.toLowerCase().includes(this.search.toLowerCase())) {
            filterSearch = job.name
              .toLowerCase()
              .includes(this.search.toLowerCase());
            return filterSearch;
          }
        }
        if (this.state !== "all") {
          filterState = job.state == this.state;
          this.currentPage = 1;
          return filterState;
        }
      });
    },
    filter() {
      return this.searchBar
        .slice()
        .reverse()
        .filter((row, index) => {
          this.total = Math.ceil((index + 1) / this.pageSize);
          let start = (this.currentPage - 1) * this.pageSize;
          let end = this.currentPage * this.pageSize;
          if (index >= start && index < end) return true;
        });
    },
  },
};
</script>

<style scoped>
#allJobs {
  padding: 50px 20px 0px 320px;
  text-align: left;
}
h1 {
  margin-bottom: 30px;
}
input {
  margin-bottom: 20px;
  margin-right: 10px;
  border-radius: 5px;
  border: 1px solid silver;
}
select {
  margin-right: 10px;
  border-radius: 5px;
  height: 27px;
  border: 1px solid silver;
}
</style>
